const STORAGE_PREFIX = "adatis.pendingPackageSale";

export interface PendingPackageSale {
  service_package_id: number;
}

const storageKey = (tenantId: number): string => `${STORAGE_PREFIX}.${tenantId}`;

export const getPendingPackageSale = (
  tenantId: number
): PendingPackageSale | null => {
  if (typeof window === "undefined" || tenantId <= 0) {
    return null;
  }

  try {
    const raw = sessionStorage.getItem(storageKey(tenantId));
    if (!raw) {
      return null;
    }

    const parsed = JSON.parse(raw) as PendingPackageSale;
    if (
      !parsed ||
      typeof parsed.service_package_id !== "number" ||
      !Number.isFinite(parsed.service_package_id) ||
      parsed.service_package_id <= 0
    ) {
      return null;
    }

    return parsed;
  } catch {
    return null;
  }
};

export const setPendingPackageSale = (
  tenantId: number,
  sale: PendingPackageSale
): void => {
  if (typeof window === "undefined" || tenantId <= 0) {
    return;
  }

  try {
    sessionStorage.setItem(storageKey(tenantId), JSON.stringify(sale));
  } catch {
    // sessionStorage unavailable
  }
};

export const clearPendingPackageSale = (tenantId: number): void => {
  if (typeof window === "undefined" || tenantId <= 0) {
    return;
  }

  try {
    sessionStorage.removeItem(storageKey(tenantId));
  } catch {
    // sessionStorage unavailable
  }
};
